import { signal } from "./common"
//获取token
export async function getToken() {
    const res = await signal({
        funcName: 'getToken',
        module: 'app'
    })
    return res.token;
}
//适当性操作
export async function risk(params) {
    const res = await signal({
        funcName: "goToRiskEvaluate",
        param: {
            content_id: params.id,
            content_type: params.type,
            risklevel: params.level,
        },
        module: 'app'
    })
    return res;
}

// 是否登录
export async function isMobileLogin() {
    const res = await signal({
        funcName: 'isMobileLogin',
        module: 'app',
    })
    return res;
}


// 调起手机号登录
export async function openMobileLogin() {
    const res = await signal({
        funcName: 'openMobileLogin',
        module: 'app'
    })
    return res;
}

// 分享
export async function getShareInfo() {
    const res = await signal({
        funcName: 'getShareInfo',
    })
    return res;
}

export async function webShare(params) {
    const res = await signal({
        funcName: "webShare",
        module: "app",
        param: params,
    });
    return res;
}

export async function goBack() {
    const res = await signal({
        funcName: 'goBack',
        module: 'app'
    })
    return res;
}

export async function closeCurrentWeb() {
    const res = await signal({
        funcName: 'closeCurrentWeb',
        module: 'app'
    })
    console.log('closeCurrentWeb');
    return res;
}


export async function updateLoginHintText() {
    try {
        const res = await signal({
            funcName: 'updateLoginHintText',
            module: 'app',
            param: {
                text: "登录预约您喜欢的直播，接收提醒"
            }
        });
        console.log(res);
    } catch (error) {
        console.log('error :>> ', error);
    }
}

export async function getLiveUserInfo() {
    const res = await signal({
        funcName: 'getLiveUserInfo',
        module: 'live'
    })
    return res;
}

export async function openProductDetail(params) {
    const res = await signal({
        funcName: 'openProductDetail',
        module: 'live',
        param: params
    })
    return res;
}
